import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import React, { useEffect, useRef, useState } from "react";
import { EBuyCarMenuRelatedType } from "@Types/constants";
import styles from "./index.module.less";
import { fetchMenuRelated } from "../../../services/buyCarStory";
import { TMenuInforResponseData } from "@Types/buyCarMenu";
import { g4Element } from "../../../utils/helper";
import { host } from "@Services/url";
import ReactDOM from "react-dom";

interface ArticleStoryProps {
    articleId?: string;
    type?: string;
}

export const Item = (props: { data: TMenuInforResponseData }) => {
    const { details, id, brandName, kindName, modelName, user } =
        props.data || {};
    const pageChange = (e) => {
        e.stopPropagation?.();
        window.open(`${host.c}/buycar/menu/details?id=${id}`, "_blank");
        g4Element("element_clicked", "查看菜單詳情", "文章頁", {
            module: "購車菜單",
            business: "銷售線索",
            element: "菜單內容",
        });
    };
    return (
        <div className={styles["story-item"]} key={id} onClick={pageChange}>
            <img src={user?.cover} className={styles["story-cover"]} />
            <div className={styles["story-brand"]}>
                {brandName} {kindName} {modelName}
            </div>
            <div className={styles["story-info"]}>
                {!!details?.date && (
                    <span>
                        {details.date.replace("-", ".").replace("-", ".")}{" "}
                    </span>
                )}
                {!!details?.regionName && (
                    <span style={{ margin: "0 6px" }}>
                        {details.regionName}{" "}
                    </span>
                )}
                {!!details?.price && <span>{` |  ${details?.price} `}</span>}
                {details?.priceTag && (
                    <div className={styles["story-tag"]}>
                        {details?.priceTag}
                    </div>
                )}
            </div>
            <div className={styles["story-view"]}>
                <b>{details?.views}</b>
                {`人查看>`}{" "}
            </div>
        </div>
    );
};

const ArticleStory: React.FC<ArticleStoryProps> = (
    props: ArticleStoryProps
) => {
    const { articleId, type } = props;
    const marqueeRef = useRef(null);
    const wrapperRef = useRef(null);
    const [num, setNum] = useState(0);
    let id = articleId;
    if (!id) {
        const temp = location.pathname.split("/");
        id = temp[temp.length - 1];
    }
    const { data } = useQuery(
        "buyCar-related",
        async () => {
            const res = await fetchMenuRelated({
                articleId: id!,
                articleType:
                    (type as EBuyCarMenuRelatedType) || window.article?.type,
                limit: "10",
            });
            if (res.status === 12000) {
                setNum((res?.data as any)?.total || 0);
                return (res.data as any)?.list;
            }
            return [];
        },
        {
            initialData: [],
        }
    );

    if (!data?.length) {
        return <></>;
    }

    const nums = Math.floor(data.length / 3);
    const animationStyle: React.CSSProperties = {
        // animationDuration: `${(nums - 1) * 5}s`,
    };

    const pageChange = () => {
        window.open(`${host.c}/buycar/menu`, "_blank");
        g4Element("element_clicked", "查看菜單列表", "文章頁", {
            module: "購車菜單",
            business: "銷售線索",
            element: "菜單內容",
        });
    };

    return (
        <div className={styles["article-story"]} onClick={pageChange}>
            <div className={styles["title"]}>相關菜單</div>
            <section className={styles["content"]}>
                <header className={styles["header"]}>
                    <span>購車菜單</span>
                    <span>
                        共<b>{num}</b>人分享{">"}
                    </span>
                </header>
                <div className={styles["marquee-wrapper"]} ref={wrapperRef}>
                    <div
                        className={styles["marquee-content"]}
                        style={animationStyle}
                        ref={marqueeRef}
                    >
                        {data.map((item, i) => (
                            <div
                                key={`${item}-${i}`}
                                className={styles["marquee-content-item"]}
                            >
                                <Item data={item} />
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ArticleStory;

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

const $app = document.getElementById("article-story");
!!$app &&
    ReactDOM.render(
        <QueryClientProvider client={queryClient}>
            <ArticleStory />
        </QueryClientProvider>,
        $app
    );
